<template>
  <div class="page-wrapper page-wrapper--glossary" data-testid="glossary-view">
    <div class="w-full">
        <div class="flex justify-between mb-8">
             <h1 class="text-[2.125rem] font-bold leading-[100%] !text-[#6CBFFF]">{{ $t('glossary_title') }}</h1>
        </div>

        <div>
          
          <div>
                <h2 class="text-white/75">{{ $t('glossary_terms') }}</h2>
                <div class="table w-[65%] max-[1400px]:w-full">
                    <div class="text-white/75">
                        <p v-html="$t('glossary_help')"></p>
                    </div>
                    <div class="w-full table" data-testid="terms-table" v-if="terms && terms.length > 0">
                        <div class="table-row">
                            <div class="table-cell align-middle pt-3 pr-3 pb-3 pl-0 box-border font-bold text-[#979797] border-b border-[#979797]">{{ $t('glossary_language_column')}}</div>
                            <div class="table-cell align-middle pt-3 pr-3 pb-3 pl-0 box-border font-bold text-[#979797] border-b border-[#979797]">{{ $t('glossary_term_column')}}</div>
                            <div class="table-cell align-middle pt-3 pr-3 pb-3 pl-0 box-border text-center font-bold text-[#979797] border-b border-[#979797]">{{ $t('team_dashboard_actions_column') }}</div>
                        </div>
                        <div class="table-row" data-testid="term-row" :data-term-id="term.id" v-for="term in terms" :key="term.id">
                            <div class="table-cell align-middle pt-3 pr-3 pb-3 pl-0 box-border">
                                <div class="flex items-center">
                                    <img class="w-[30px] mr-[10px]" :src="'/data/flags/' + getLangFlag(term.language) + '.png'"/>
                                    <span class="text-white/75">{{ getLangTitle(term.language) }}</span>
                                </div>
                            </div>
                            <div class="table-cell align-middle pt-3 pr-3 pb-3 pl-0 box-border text-white/75">{{ term.term }}</div>
                            <div class="table-cell align-middle pt-3 pr-3 pb-3 pl-0 box-border text-center">
                                <a href="javascript:;" class="text-[#EA4335] font-bold" data-testid="delete-term-button" :data-term-id="term.id" @click="deleteTerm(term.id)" >	&#10060; {{ $t('commont_delete') }}</a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="mt-[30px]" data-testid="add-term-form" v-if="adding">
                            <form action="#" @submit.prevent="addTerm" method="POST">
                                <div class="flex items-center gap-5 relative">
                                    <div class="w-2/5 relative text-white" data-testid="language-selector-container">
                                        <label class="flex font-bold mb-2">Select language</label>
                                        <language-selector-light @select="setLang"></language-selector-light>
                                    </div>
                                    <div class="flex flex-col text-white">
                                        <label class="flex font-bold mb-2">{{ $t('glossary_field_placeholder') }}</label>
                                        <input type="text" data-testid="term-input" class="border-2 border-[#505050] rounded-[10px] font-normal text-base leading-[1.18rem] bg-transparent px-[10px] h-[44px] w-[350px] outline-none text-white/75" :placeholder="$t('glossary_field_placeholder')" required v-model="newTerm.text" :class="{error: newTerm.errors.text}">
                                    </div>
                                </div>
                                <div class="flex gap-6 mt-3">
                                    <button type="submit" data-testid="confirm-add-term" class="border-none outline-none text-[#6CBFFF] flex items-center bg-none cursor-pointer font-bold disabled:text-[#979797]"><span class="text-[1.5rem] mr-2"> &check;</span>{{ $t('common_confirm') }}</button>
                                    <a href="javascript:;" data-testid="cancel-add-term" class="text-white/75 font-normal flex items-center" @click="cancelAdding()">{{ $t('common_cancel') }}</a>    
                                </div>
                            </form>
                    </div>
                    <div class="mt-3"  v-if="!adding">
                        <div class="table-cell align-middle px-3 py-3 pl-0 box-border">
                            <div class="flex gap-3">
                                <a class="text-[#6CBFFF] font-bold flex items-center" data-testid="add-term-button" href="javascript:;" @click="setAdding(true)">
                                    <span class="text-[1.5rem] mr-2">+</span>
                                    {{ $t('glossary_add') }}</a>
                                <span class="flex items-center text-[#979797]" data-testid="terms-available-count"> {{ $t('common_available') }}: {{ termsAvailable }}</span>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
              </div>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import GlossaryService from '@/services/glossary.service';
import LanguageSelectorLight from '@/components/LanguageSelectorLight.vue';

export default {
  name: 'GlossaryView',
  components: {
    LanguageSelectorLight
  },
  data() {
    return {
        plan: false,
        terms: [],
        newTerm: {
            text: "",
            language: "all",
            errors: {
                text: false
            }
        },
        adding: false,
    }
  },
  methods: {
    openBeacon() {
      window.Beacon('open');
    },
    setAdding(bool) {
        this.adding = bool;
    },
    cancelAdding() {
        this.setAdding(false);
        this.newTerm.text = "";
        this.newTerm.errors.text = false;
    },
    getTerms() {
        GlossaryService.getTerms().then((data) => {
            this.terms = data.data.result;
        })
    },
    addTerm() {
        GlossaryService.addTerm(this.newTerm.text, this.newTerm.language).then(() => {
           this.getTerms();
           this.cancelAdding();
        }).catch((error) => {
            console.log(error);
        });
    },
    deleteTerm(term_id) {
        this.$dialog.confirm('glossary_term_delete_warn', {
            confirmLabel: 'common_yes',
            danger: true,
        }).then((confirmed) => {
            if (confirmed) {
                GlossaryService.deleteTerm(term_id).then(() => {
                  this.getTerms();
                  this.$toast.success('glossary_term_delete_success');
                })
            }
        });
        
    },
    getLangFlag(lang_shortcode) {
        if (lang_shortcode != 'all') {
            const lang_found = this.languages.find(element => element.code == lang_shortcode);
            return lang_found.code;
        } else {
            return 'all';
        } 
    },
    getLangTitle(lang_shortcode) {
        if (lang_shortcode != 'all') {
            const lang_found = this.languages.find(element => element.code == lang_shortcode);
            return lang_found.name;
        } else {
            return this.$t('glossary_all_lang');
        }  
    },
    setLang(lang) {
        let selected = lang.code;
        if (lang.code == 'zh') {
            selected = lang.code;
        }
       this.newTerm.language = selected;
    }
  },
  computed: {
    ...mapState('auth', ['token', 'authorized']),
    ...mapState('nonpersist', ['user']),
    ...mapState('lang', ['languages']),
    termsAvailable() {
        return  this.user.features.custom_terms.total_allowed_items - this.terms.length;
    },
    termsTotal() {
       return this.user.features.custom_terms.total_allowed_items; 
    },
    addedTerms() {
        return this.terms.length;
    },
  },
  watch:{
    
  },
  async mounted() {
    await this.getTerms();
  },
  created() {
  }
}
</script>

<style lang="scss">

    .page-wrapper {
        padding-top: 5rem;
        display: flex;
        flex-direction: column;

        &--glossary {
            width: 90%;
            margin: 0 auto;
            padding-bottom: 5rem;
            img {
                max-width: 57rem;
            }

            h1 {
                font-size: 3rem !important;
                margin: 0.3em 0;
            }
        }

        .about-text {

            p {
                margin: 30px 0 0;
                text-transform: uppercase;
                font-size: 1.25rem;
                line-height: 1.875rem;
                text-align: center;
                color: #000000;
            }
        }
    }

    .pricing {
      width: 100%;

        &-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 2rem;

            &__left {
                font-size: 1.25rem;
                line-height: 100%;
                font-weight: 400;
                color: #979797;
                display: flex;
                align-items: center;
            }

            &__right {
                font-weight: 400;
                font-size: 1.375rem;
                line-height: 150%;
                color: #3D485A;
                display: flex;

                .toggle-container {
                    margin: 0 1rem;
                }
            }
        }

        .buttons-row {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            column-gap: 11px;

            .button-column {
                padding: 0 1.5rem 0;
            }
        }
        .subscribe-btn {
            background: #6CBFFF;
            border-radius: 25px;
            color: #fff;
            text-transform: uppercase;
            font-size: 1rem;
            line-height: 1.2rem;
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: 0.15em;
            height: 2.8rem;
            justify-content: center;
            font-weight: 700;
            margin: 11px auto 0;
            width: 80%;

            &:hover {
                filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
            }

            &--margined {
                margin-top: 25px;
            }
        }

        .current-selected {
          text-transform: uppercase;
          font-size: 1rem;
          line-height: 1.2rem;
          display: flex;
          align-items: center;
          text-align: center;
          letter-spacing: 0.15em;
          height: 2.8rem;
          justify-content: center;
          font-weight: 700;
          margin: 11px auto 0;
          width: 80%;

          &.current-selected--downgrade {
                text-transform: none;
                /* line-height: 1rem; */
                letter-spacing: 0.1em;
                width: 90%;
          }
        }

        &-footer {
            display: flex;
            justify-content: center;
            font-weight: 400;
            font-size: 1.6rem;
            line-height: 120%;
            /* identical to box height, or 30px */

            display: flex;
            align-items: center;
            text-align: center;
            font-feature-settings: 'pnum' on, 'lnum' on;

            color: #979797;
            margin-top: 6rem;
            padding-bottom: 2.25rem;

            a {
                font-weight: 700;
                font-size: 1.6rem;
                /* identical to box height, or 38px */

                display: flex;
                align-items: center;
                text-align: center;
                text-decoration-line: underline;

                /* Gold */

                color: #6CBFFF;
                margin-left: 1rem;
            }
        }
    }
    :deep(.popper) {
        max-width: 200px !important;
        text-align: left !important;
        font-size: 0.8rem !important;
        line-height: 150% !important;
        font-weight: 400;
        padding: 1rem;
    }

    .tabs-controls {
      margin-bottom: 30px;
      display: flex;
      column-gap: 2.25rem;

      a {
        color: #000;
        font-weight: 700;
        font-size: 2.25rem;
        line-height: 100%;
        padding-bottom: 10px;
        border-bottom: 2px solid transparent;

        &.active {
          color: #6CBFFF;
          border-color: #6CBFFF;
        }
      }
    }

    .tabs-controls__subheader {
      
        margin-bottom: 30px;
        font-size: 1.25rem;
        line-height: 125%;
        width: 90%;
      
    }

    .contact-link {
      font-weight: 700;
      font-size: 1.6rem;
      display: flex;
      align-items: center;
      text-align: center;
      -webkit-text-decoration-line: underline;
      text-decoration-line: underline;
      color: #6CBFFF;
      justify-content: center;
      margin-top: 1rem;
    }

    input[type=number] { 
        -moz-appearance: textfield;
        appearance: textfield;
        margin: 0; 
    }

    .form-inner {
        display: flex;
        align-items: center;
        column-gap: 20px;
        position: relative;

        label {
            display: flex;
            font-weight: bold;
            margin-bottom: 10px;
        }
    }

    .word-input {
        display: flex;
        flex-direction: column;
    }

    .lang-selector-wrap {
        width: 40%;
        position: relative;
    }

    .term-adding {
        margin-top: 30px;
    }

    .lang-span {
        display: flex;
        align-items: center;

        img {
            max-width: 30px;
            margin-right: 10px;
        }

        span {
            font-size: 1rem;
            line-height: 1.18rem;
        }
    }
</style>
